require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.number.is-finite.js");
// 最多两位小数的非负数字原文，不接受科学计数法、正负号和千分位
var AT_MOST_TWO_DECIMALS = /^(?:0|[1-9]\d*)(?:\.\d{1,2})?$/;
function rawText(value) {
  if (value === null || value === undefined) return '';
  return String(value);
}

// 返回 empty / invalid / ok。先看原文格式，再用有限数值判断范围
function validateDecimalAmount(value, min, max) {
  var raw = rawText(value);
  if (raw === '') return 'empty';
  if (!AT_MOST_TWO_DECIMALS.test(raw)) return 'invalid';
  var num = Number(raw);
  if (!Number.isFinite(num) || num < min || num > max) return 'invalid';
  return 'ok';
}

// 正常缴存时的公司/个人福利基金比例：[0.01, 100]
function validateWelfareFundRatio(value) {
  return validateDecimalAmount(value, 0.01, 100);
}

// 累计已交福利基金：[0, 1000000000]
function validateSalaryLastWf(value) {
  return validateDecimalAmount(value, 0, 1000000000);
}
module.exports = {
  validateWelfareFundRatio: validateWelfareFundRatio,
  validateSalaryLastWf: validateSalaryLastWf
};